<template>
    <div class="fixed-footer">
        <div class="gs:grid lg:justify-content-between align-items-center display-contents">
                <div class="col-10 hidden md:block">
                    <span class="tx-18 mb-3 md:mb-0 md:mr-4 text-green-ad weight-600">
                        ¿No está el auto que estás buscando?
                    </span>
                    <p class="tx-white tx-inline-block">Dinos cuál es, lo buscamos para ti.</p>
                </div>
                <p class="col-10 tx-white md:hidden">Haz clic aquí si no encontraste un auto.</p>
                <div class="flex justify-content-end col-5 mt-1">
                    <button @click="openModalUser()" class="btn btn--green-ad py-3 mr-8">
                        Buscar en agencias
                    </button>
                </div>
        </div>
        <user-modal :showModal="showModalUser" @closeModal="closeModal"></user-modal>
    </div>
</template>
<script>
import UserModal from './UserFindModal.vue'
export default {
    components: {
        UserModal
    },
    data() {
        return {
            showModalUser: false
        }
    },
    methods: {
        openModalUser () {
            this.showModalUser = true;
        },
        closeModal () {
            this.showModalUser = !this.showModalUser;
        }
    },
}
</script>
<style lang="scss">
    .fixed-header, .fixed-footer{
        width: 100%;
        position: fixed;
        background: #000;
        padding: 15px 30px;
        z-index: 1;
    }
    .fixed-footer{
        bottom: 0;
    }
    @media(min-width: 768px) {
        .tx-inline-block {
            display: inline-block;
        }
    }

    @media (max-width: 600px) {
        .fixed-header, .fixed-footer{
            padding: 5px 10px;
        }
        .fixed-footer .btn--green-ad {
            font-size: 12px;
            padding: 4px 12px;
        }
        .mr-8 {
            margin-right: 0.1rem;
        }
        .tx-18 {
            font-size: 1rem;
        }
    }
    @media (max-width: 320px) {
        .tx-18 {
            font-size: 14px;
        }
        .tx-white {
            font-size: 14px;
        }
    }
</style>
